import { gql } from '@apollo/client';
import type { ShopConnection, ShopOrderEnum } from '@/api/types/shop.types';

export interface GetShopsData {
  shops: ShopConnection;
}

export interface GetShopsVars {
  after?: string | null;
  before?: string | null;
  first?: number | null;
  last?: number | null;
  order?: ShopOrderEnum | null;
  search?: string | null;
  seed?: number | null;
  categoriesIds?: string[] | null;
}

export const GET_SHOPS = gql`
  query GetShops(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $order: ShopOrderEnum
    $search: String
    $seed: Int
    $categoriesIds: [ID!]
  ) {
    shops(
      after: $after
      before: $before
      first: $first
      last: $last
      order: $order
      search: $search
      seed: $seed
      categoriesIds: $categoriesIds
    ) {
      nodes {
        id
        logo {
          url
        }
        name
        adsCount
        isFavorited
        timeOnPlatform
        uri
        categories {
          id
          name
          slug
          path
          count
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`;
